module.exports = __webpack_public_path__ + "static/media/noVisitada.d75fc70d.svg";